var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92 6.956L5.45 5.473M14.759 6.956L16.229 5.473M5.449 16.353L6.919 14.869M10.839 4.979V3M4.959 10.913H3M16.875 16.836L20.689 15.33C20.781 15.2932 20.8599 15.2296 20.9155 15.1475C20.971 15.0655 21.0007 14.9686 21.0007 14.8695C21.0007 14.7704 20.971 14.6735 20.9155 14.5915C20.8599 14.5094 20.781 14.4458 20.689 14.409L11.524 10.794C11.4348 10.7595 11.3374 10.7517 11.2439 10.7717C11.1503 10.7916 11.0646 10.8384 10.9972 10.9063C10.9298 10.9742 10.8837 11.0603 10.8645 11.154C10.8452 11.2478 10.8538 11.345 10.889 11.434L14.471 20.685C14.633 21.105 15.221 21.105 15.383 20.685L16.875 16.836Z",
    stroke: "#2783EC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClick);
export default __webpack_public_path__ + "static/media/icon-click.08c734bc73e961267a9749f9801fd197.svg";
export { ForwardRef as ReactComponent };